const Login1 = () => import('@/views/Login1')

export default [
  {
    path: '/login1',
    component: Login1
  }
]
